<template>
  <div style="border: 0px solid black; width:100%;overflow: auto">
    <div style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;">
        <b>{{$t('mobile.top_title')}}</b>

        <lte-button
        v-if="authorizedRole(role) <= 2"
        style ="float:right;"
        type="btn btn-primary"
        right_icon="fa fa-plus"
        @click="showCreateApplicationModal"
        >
        {{$t('user.addnew')}}
        </lte-button>
    </div>

    <div class="container-fluid" style="padding: 0">
      <div id="accordion" role="tablist" aria-multiselectable="true">
        <div
          class="panel panel-default"
          style="border: none"
          v-for="app in mobileApplicationDataList"
          :key="app.id"
        >
          <div
            class="panel-heading clearfix callout callout-info"
            style="background-color: white !important; width: 100%; padding: 5px; border-bottom: none"
            role="tab"
            :id="'version_' + app.id"
          >
            <h5
              class="panel-title pull-left"
              style="padding-top: 5px">
              <a
                style="margin-left: 5px; text-decoration: none; color: black"
                data-toggle="collapse"
                data-parent="#accordion"
                aria-expanded="false"
                :aria-controls="'application_' + app.id"
                :href="'#application_' + app.id"
                @click="getApplicationOSDetail(app.id)"
              >{{ app.name }} - {{ app.code }}
              </a>
            </h5>

            <div class="btn-group pull-right" style="z-index: 10">
              <button type="button" class="btn btn-box-tool content-no-margin" @click="getModalApplication(app, $event)">
                  <i class="fa fa-edit"></i>
              </button>
              <button type="button" class="btn btn-box-tool content-no-margin" @click="showModalApplication(app, $event)">
                  <i class="fa fa-close"></i>
              </button>
            </div>
          </div>

          <div
            :id="'application_' + app.id"
            class="panel-collapse collapse"
            role="tabpanel"
            :aria-labelledby="'version_' + app.id"
          >
            <div
                v-for="os in mobileAppOperationSystemDataList"
                :key="os.id"
                class="table-responsive"
                style="overflow-y: hidden"
              >
                <table class="table">
                  <thead>
                  <tr>
                    <th style="width: 20%">
                      <span v-if="!os.isEditing">OS: {{os.name}}</span>
                      <input v-else type="text" class="form-control" v-model="os.name">
                    </th>

                    <th style="width: 20%">Version</th>
                    <th style="width: 20%">Release</th>
                    <!-- <th style="width: 20%">Status</th> -->
                    <th style="width: 10%">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    v-for="version in mobileAppOSVersionDataList"
                    :key="version.id"
                  >
                  <!-- Date Created -->
                    <td v-if="version.os_id == os.id">
                      <input
                        type="text"
                        style="border: none; outline: none"
                        v-model="version.date_created"
                        :disabled="!version.isEditing"
                      >
                    </td> <!-- Date Created  -->
                    <td v-if="version.os_id == os.id">
                      <span>
                        <input
                          type="text"
                          class="version-input"
                          v-model="version.major"
                          :disabled="!version.isEditing"
                        >.
                        <input
                          type="text"
                          class="version-input"
                          v-model="version.minor"
                          :disabled="!version.isEditing"
                        >.
                        <input
                          type="text"
                          class="version-input"
                          v-model="version.build"
                          :disabled="!version.isEditing"
                        >
                      </span>
                    </td>

                    <td v-if="version.os_id == os.id">
                      <span class="label label-success">Beta</span>
                    </td>

                    <td v-if="version.os_id == os.id">
                      <button
                        type="button"
                        class="btn btn-danger btn-xs content-no-margin"
                        @click="showDeleteVersionModal(version, app.id)"
                      >
                        <i class="fa fa-trash"></i>
                      </button> <!-- Delete Button -->
                    </td>
                  </tr>

                  </tbody>
                </table>
                <!-- /.box-body -->
                <div class="box-footer clearfix">
                  <button
                    v-if="false"
                    class="btn btn-sm btn-default pull-left"
                    style="background-color:white; margin-right: 10px"
                    @click="onEditOperationSystem(os)"
                  >
                    <i class="fa fa-edit"></i>&nbsp;Edit
                  </button>
                  <button
                    v-if="false"
                    class="btn btn-sm btn-default pull-left"
                    style="background-color:white; margin-right: 10px"
                    @click="onUpdateOperationSystem(os)"
                  >
                    <i class="fa fa-save"></i>&nbsp;Save
                  </button>
                  <button
                    class="btn btn-sm btn-default pull-left"
                    style="background-color:white; margin-right: 10px"
                    @click="showModalOperationSystem(os)"
                  >
                    <i class="fa fa-eraser"></i>&nbsp;Remove
                  </button>

                  <button
                    class="btn btn-sm btn-default pull-right"
                    style="background-color:white; margin-right: 10px"
                    @click="showCreateVersionModal(os, app)"
                  >
                    <i class="fa fa-plus"></i>&nbsp;Generate Version
                  </button>
                </div>
                  <!-- /.box-footer -->
              </div>
              <!-- /.table-responsive -->
          </div>
        </div>
      </div>
    </div>




    <!-- Modal -->
    <lte-modal
      v-if="isModalVisible"
      @onConfirm="removeSelectOption(deleteSelectOption)"
      @close="closeModal"
      :item="objModal[0]"
    ></lte-modal> <!-- /.Modal -->

    <!-- Moble App Modal -->
    <mobile-app-modal
      v-show="isModalApplicationVisible"
      @onSaveApplication="onSaveApplication"
      :item="applicationRecordData[0]"
    ></mobile-app-modal> <!-- /.Moble App Modal -->

    <!-- Moble Version Modal -->
    <mobile-version-modal
      v-show="isModalCreateVersionVisible"
      @onSaveVersion="onSaveVersion"
      :item="versionRecordData[0]"
    ></mobile-version-modal> <!-- Moble Version Modal -->

    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar">
    </lte-core-alert>

    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF">
    </loading>

  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import LTEButton from "@/components/LTEButton.vue";
// import LTETable from "@/components/LTETable.vue";
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import MobileAppModal from "@/components/MobileApplicationModal.vue";
import MobileVersionModal from "@/components/MobileVersionModal.vue";
import XLSX from "xlsx";
// import Paginator from "@/components/Paginator.vue";
import Loading from "vue-loading-overlay";
import constantData from "@/lib/constantsData";
import utils from '@/lib/utils'

export default {
  name: "MobileList",
  data() {
    return {
      buttonName: "danger",
      labelName: "Name",
      gridQuestionDataList: [],
      useFilter:false,
      version_data: {
          minMajor: 0,
          minMinor: 0,
          minBuild: 0,

          maxMajor: 3,
          maxMinor: 2,
          maxBuild: 2,
      },
      tool: {
          isMin: false,
          isMax: false
      },
      gridColumns: [
        { name: "common.nonumber", style: { width: '5%' }},
        { name: "mobile.app_name", style: { width: '30%' }},
        { name: "mobile.app_description", style: { width: '56%' }},
      ],
      hdBackground: {
          backgroundColor: '#4b646f',
          color: 'white',
          border:'1px solid white'
        },
      adminActions: [
        "common.modify",
        "common.delete"
      ],
      staffActions: [
        "common.modify"
      ],
      tblBorder: "border: 1px solid orange",
      isModalVisible: false,
      isModalApplicationVisible: false,
      isModalCreateVersionVisible: false,
      objModal: [
        {
          title: 'mobile.inform_modal[0].title',
          body: 'mobile.inform_modal[0].del_body',
          buttonNo: 'mobile.inform_modal[0].modal_btn[0].cancel',
          buttonYes: 'mobile.inform_modal[0].modal_btn[0].confirm',
          styleType: "danger"
        }
      ],

      json_data_survey: [],

      paginatorItem: {
        commit_function: "GET_SURVEYQUESTION_LIST"
      },
      search: {
        code: "",
        username: "",
        full_name: "",
        phone: "",
        gender: "",
        email: "",
        privilege: "",
        country_name: "",
      },
      isLoading: false,

      deleteSelectOption: "",
      mobileApplicationDataList: [],
      mobileAppOperationSystemDataList: [],
      mobileAppOSVersionDataList: [],
      versionRecordData: [],
      osRecordData: [],
      applicationRecordData: []
    };
  },
  watch: {

    GET_MOBILE_APPLICATION_DATA: function() {
      this.mobileApplicationDataList = [];

      this.GET_MOBILE_APPLICATION_DATA.forEach((app) => {
        let app_id = app.id;
        let app_name = app.name;
        let app_description = app.description;
        let app_date_created = app.date_created;
        let app_code = app.code;

        let data = {
          id: app_id,
          name: app_name,
          code: app_code,
          description: app_description,
          date_created: app_date_created
        }

        this.mobileApplicationDataList.push(data);
      })
    },

    GET_MOBILE_OS_DATA: function() {
      this.mobileAppOperationSystemDataList = [];
      let os_list = [];

      this.GET_MOBILE_OS_DATA.forEach((os) => {
        let app = os.application
        let os_id = os.id;
        let os_name = os.name;
        let os_date_created = os.date_created;

        let data = {
          app_id: app.id,
          id: os_id,
          name: os_name,
          date_created: os_date_created,
          isEditing: false
        }
        this.mobileAppOperationSystemDataList.push(data);
        os_list.push(os_id);
      })

      this.getApplicationOSVersion(os_list);
    },

    GET_MOBILE_OS_VERSION_DATA: function() {
      this.mobileAppOSVersionDataList = [];

      this.GET_MOBILE_OS_VERSION_DATA.forEach((ver) => {
        let os = ver.operation_system;
        let ver_id = ver.id;
        let ver_major = ver.major;
        let ver_minor = ver.minor;
        let ver_build = ver.build;
        let ver_date_created = utils.formatSqlDate(ver.date_created, null, "DD-MM-YYYY HH:mm:ss");
        let ver_is_active = ver.isActive;

        let data = {
          os_id: os.id,
          id: ver_id,
          date_created: ver_date_created,
          major: ver_major,
          minor: ver_minor,
          build: ver_build,
          isMax: false,
          isMin: false,
          isEditing: false,
          isActive: ver_is_active
        }
        this.mobileAppOSVersionDataList.push(data)
      })
    }
  },

  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_MOBILE_APPLICATION_DATA",
      "GET_MOBILE_OS_DATA",
      "GET_MOBILE_OS_VERSION_DATA",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_ACCOUNT_DATA"
    ]),
    role: function() {
      return this.GET_ACCOUNT_DATA.id;
    },
  },

  methods: {
      ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_MOBILE_APPLICATION_LIST",
      // "GET_MOBILE_APPLICATION_DETAIL",
      "GET_MOBILE_OS_LIST",
      // "GET_MOBILE_OS_DETAIL",
      "GET_MOBILE_OS_VERSION_LIST",
      // "GET_MOBILE_OS_VERSION_DETAIL",
      "DELETE_MOBILE_APPLICATION",
      "DELETE_MOBILE_OS",
      "DELETE_MOBILE_OS_VERSION",
      "UPDATE_MOBILE_APPLICATION",
      "UPDATE_MOBILE_OS",
      // "UPDATE_MOBILE_OS_VERSION",
      "ADD_MOBILE_APPLICATION",
      // "ADD_MOBILE_OS",
      "ADD_MOBILE_OS_VERSION",

      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
    ]),

    /*********************************************************************
     * VERSION
    *********************************************************************/
    changeVersionStatus: function(version) {
      version.isActive = !version.isActive;
    },

    // Get Application Detail When Clicking on Box
    getApplicationOSDetail: function(appID){
      const app_data = {
        params: {
          application: appID
        }
      }
      this.GET_MOBILE_OS_LIST(app_data);
    },

    // Get Application OSs' Versions Based On Application OS
    getApplicationOSVersion: function(osID){
      const os_data = {
        params: {
          operation_system: osID
        }
      }
      this.GET_MOBILE_OS_VERSION_LIST(os_data)
    },

    onEditVersion: function(version) {
      version.isEditing = true;
    },

    showDeleteVersionModal: function(version, app_id) {
      this.versionRecordData = [];
      this.isModalVisible = true;
      this.versionRecordData.push(version, {'app_id': app_id});
      this.deleteSelectOption = "os_version";
      this.objModal[0].body = "mobile.inform_modal[0].body.version";
    },

    closeModal: function() {
      this.isModalVisible = false;
    },

    removeSelectOption: function(option) {
      if (option == "operation_system") {
        return this.onRemoveOperationSystem();
      } else if (option == "os_version") {
        return this.onDeleteVersion()
      } else if (option == "application") {
        return this.onRemoveApplication();
      } else if (option == "change_version_status") {
        //
      }
    },

    showCreateVersionModal: function(os, app) {
      let versionItem = null;

      for (let i = 0, size = this.mobileAppOSVersionDataList.length; i < size; i++) {
        const element = this.mobileAppOSVersionDataList[i];
        if (os.id == element.os_id) {
          versionItem = element;
          break;
        }
      }

      let data = {
        app_name: app.name,
        app_id: app.id,
        os_name: os.name,
        os_id: os.id,
        latest_version: versionItem
      }

      this.versionRecordData = []
      this.isModalCreateVersionVisible = true;
      $('#modal-mobile-version').modal('show');
      this.versionRecordData.push(data);
    },

    onSaveVersion: function(ver_data) {
      if (parseInt(ver_data.id) == 0) {
        this.ADD_MOBILE_OS_VERSION(ver_data)
        .then(
          function(res) {
            this.isModalCreateVersionVisible = false;
            $('#modal-mobile-version').modal('hide');

            this.SUCCESS_TOAST();
            const app_data = {
              params: {
                application: ver_data.application
              }
            }
            this.GET_MOBILE_OS_LIST(app_data);
          }.bind(this)
        )
        .catch(
          function (error) {
            this.ERROR_TOAST();
          }.bind(this)
        )
      }

    },

    onDeleteVersion: function() {
      this.isModalVisible = false;
      this.DELETE_MOBILE_OS_VERSION(this.versionRecordData[0])
        .then(
          function(res) {
            this.SUCCESS_TOAST();

            const app_data = {
              params: {
                application: this.versionRecordData[1].app_id
              }
            }
            this.GET_MOBILE_OS_LIST(app_data);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ERROR_TOAST()
          }.bind(this)
        )
    },


    /*********************************************************************
     * OPERATION SYSTEM
    *********************************************************************/
    onUpdateOperationSystem: function(os) {
      let data = {
        id: os.id,
        name: os.name,
        description: "",
        application: os.app_id
      }

      this.UPDATE_MOBILE_OS(data)
        .then(
          function(res) {
            os.isEditing = false;
            this.SUCCESS_TOAST();

            const app_data = {
              params: {
                application: os.app_id
              }
            }
            this.GET_MOBILE_OS_LIST(app_data);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ERROR_TOAST();
          }.bind(this)
        )

    },

    onEditOperationSystem: function(os) {
      os.isEditing = true;
    },

    showModalOperationSystem: function(os) {
      this.osRecordData = [];
      this.isModalVisible = true;
      this.osRecordData.push(os);
      this.deleteSelectOption = "operation_system";
      this.objModal[0].body = "mobile.inform_modal[0].body.operation_system";
    },

    onRemoveOperationSystem: function() {
      this.isModalVisible = false;
      this.DELETE_MOBILE_OS(this.osRecordData[0])
        .then(
          function(res) {
            this.SUCCESS_TOAST();

            const app_data = {
              params: {
                application: this.osRecordData[0].app_id
              }
            }
            this.GET_MOBILE_OS_LIST(app_data);
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ERROR_TOAST();
          }.bind(this)
        )

    },


    /*********************************************************************
     * APPLICATION
    *********************************************************************/
    showCreateApplicationModal: function() {
      this.applicationRecordData = [];
      this.isModalApplicationVisible = true;
      $('#modal-mobile-application').modal('show');
    },

    /**
     * Including Create and Update Application
     */
    onSaveApplication: function(app_data) {
      this.isModalApplicationVisible = false;
      $('#modal-mobile-application').modal('hide');

      if (parseInt(app_data.id) == 0){
        this.ADD_MOBILE_APPLICATION(app_data)
        .then(
          function(res) {
            this.SUCCESS_TOAST();
            this.GET_MOBILE_APPLICATION_LIST();
            this.applicationRecordData[0] = {}
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ERROR_TOAST();
          }.bind(this)
        )
      } else {
        this.UPDATE_MOBILE_APPLICATION(app_data)
        .then(
          function(res) {
            this.SUCCESS_TOAST();
            this.GET_MOBILE_APPLICATION_LIST();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ERROR_TOAST();
          }.bind(this)
        )
      }

    },

    onUpdateApplication: function(app_data) {
      this.isModalApplicationVisible = false;
      $('#modal-mobile-application').modal('hide');
      this.UPDATE_MOBILE_APPLICATION(app_data)
        .then(
          function(res) {
            this.SUCCESS_TOAST();
            this.GET_MOBILE_APPLICATION_LIST();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ERROR_TOAST();
          }.bind(this)
        )
    },

    showModalApplication: function(app, event) {
      event.stopPropagation();
      this.applicationRecordData = [];
      this.isModalVisible = true;
      this.applicationRecordData.push(app);
      this.deleteSelectOption = "application";
      this.objModal[0].body = "mobile.inform_modal[0].body.application";
    },

    onRemoveApplication: function(app) {
      this.isModalVisible = false;
      this.DELETE_MOBILE_APPLICATION(this.applicationRecordData[0])
        .then(
          function(res) {
            this.SUCCESS_TOAST();
            this.GET_MOBILE_APPLICATION_LIST();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ERROR_TOAST();
          }.bind(this)
        )
    },

    getModalApplication: function(app, event) {
      // Stop Event Listener of Parent Component
      event.stopPropagation();
      this.applicationRecordData = [];
      this.applicationRecordData.push(app);
      this.isModalApplicationVisible = true;
      $('#modal-mobile-application').modal('show');
    },

    authorizedRole: function(userID) {
      let userGroup = this.GET_ACCOUNT_DATA.group_id;

      if (userID == 1 || userID == 2) {
        return 1;
      } else if (userID > 2) {
        if (userGroup == 1) {
          return 2;
        }
      } else {
        return 3;
      }
    },
    clickToSmallBox() {
      alert("click!!!: clickToSmallBox");
    },
    callback: function() {
      this.$router.push({
        name: "QuestionAdd",
        params: {
          id: 0
        },
      });
    },
    onExport: async function() {
      await this.GET_SURVEYQUESTION_LIST().then(
        function(res) {
          let result = res.data;
          result.results.forEach(c => {
            let json_data = {
              "Tên Cuộc Khảo Sát": c.survey_name,
              "Người Tạo Khảo Sát": c.created_by,
              "Ngày Khảo Sát": utils.formatSqlDate(c.date_of_survey, null, "DD-MM-YYYY"),
              "Loại Câu Hỏi": this.$t(constantData.questionType[c.type_of_question_code - 1].text),
              "Nội Dung Câu Hỏi": c.question_details
            };
            this.json_data_survey.push(json_data);
          });
        }.bind(this)
      );

      // export json to Worksheet of Excel
      // only array possible
      var surveys = XLSX.utils.json_to_sheet(this.json_data_survey);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, surveys, "SurveyQuestion"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // export Excel file
      XLSX.writeFile(wb, "SurveyQuestions.xlsx"); // name of the file is 'book.xlsx'
    },

    importExcel: function() {
      this.$router.push({
        name: "CustomerImportExcel",
        params: {
          id: 0
        }
      });
    },

    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_SURVEYQUESTION_LIST"
      };
      this.PAGINATION_PREV_PAGE(data);
    },
    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_SURVEYQUESTION_LIST"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },
    onPagination: function(data) {
      this.GET_SURVEYQUESTION_LIST(data);
    }
  },
  async mounted() {
    await this.GET_MOBILE_APPLICATION_LIST();
  },

  components: {
    "lte-button": LTEButton,
    // "lte-table": LTETable,
    "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    // 'paginator': Paginator,
    "loading": Loading,
    "mobile-app-modal": MobileAppModal,
    "mobile-version-modal": MobileVersionModal
  }
};
</script>

<style scoped>
.content-no-margin {
    margin: 0;
}

.content-no-padding {
  padding: 0;
}

.header-pointer {
  cursor: pointer;
}

.version-input {
  outline: none;
  border: none;
  width: 17px;
}

input[type="text"]:disabled {
  background-color: transparent;
}

</style>












// WEBPACK FOOTER //
// src/views/Mobile/MobileList.vue